let BASE_URL = process.env.VUE_APP_REPORT_BASE_URL;
export default BASE_URL;
